"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var levels = _a.theme.palette.elevation, elevation = _a.elevation;
    return (elevation in levels ? "box-shadow: " + levels[elevation] + ";" : '');
});
